export default "__VITE_ASSET__BgQGBlbL__"